import { usePageSEO } from '@/hooks/usePageSEO';
import FadeInSection from '@/components/base/FadeInSection';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero404 from './components/Hero404';
import LiensRapides from './components/LiensRapides';
import Urgence404 from './components/Urgence404';
import Recherche404 from './components/Recherche404';

export default function NotFound() {
  usePageSEO({
    title: 'Page non trouvée | Couvreur-Lévis.com',
    description: "Cette page n'existe pas. Retournez à l'accueil ou explorez nos services de toiture à Lévis.",
    urlPath: '',
    noindex: true,
    nofollow: false,
  });

  return (
    <>
      <Header />
      <main>
        <Hero404 />
        <FadeInSection delay={150}><LiensRapides /></FadeInSection>
        <FadeInSection delay={300}><Urgence404 /></FadeInSection>
        <FadeInSection delay={450}><Recherche404 /></FadeInSection>
      </main>
      <Footer />
    </>
  );
}